import React, {type MouseEventHandler} from "react";

export enum ButtonType {
  PRIMARY,
  SECONDARY
}

const ButtonTypeClass = {
  [ButtonType.PRIMARY]: "btn-primary",
  [ButtonType.SECONDARY]: "btn-secondary"
};

interface SpinnerButtonProps {
  onClick: MouseEventHandler;
  children: React.ReactNode;
  showSpinner: boolean;
  buttonType?: ButtonType;
  className?: string;
}

const getButtonTypeClass = (buttonType: ButtonType) => ButtonTypeClass[buttonType] ?? "";

export const SpinnerButton = ({
  onClick,
  children,
  showSpinner,
  className = "",
  buttonType = ButtonType.PRIMARY
}: SpinnerButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className={`btn ${getButtonTypeClass(buttonType)} btn-dark ${className}`}>
    {showSpinner && (
      <i className="fad spinner fa-spinner-third fa-spin icon-default icon-loader"></i>
    )}{" "}
    {children}
  </button>
);
